import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "pane"]

  connect() {
    const active = this.tabTargets.find(t => t.getAttribute("aria-selected") === "true")
    if (active) this.#activate(active.dataset.tab)
  }

  select(event) {
    this.#activate(event.currentTarget.dataset.tab)
  }

  #activate(tabName) {
    this.tabTargets.forEach(t => {
      const selected = t.dataset.tab === tabName
      t.setAttribute("aria-selected", selected)
      t.classList.toggle("telemetry__media-tab--active", selected)
    })

    this.paneTargets.forEach(p => {
      p.hidden = p.dataset.tab !== tabName
    })

    this.element.dispatchEvent(new CustomEvent("telemetry-tabs:activated", {
      bubbles: true,
      detail: { tab: tabName }
    }))
  }
}
